import { render, staticRenderFns } from "./ListChapter.vue?vue&type=template&id=01dd2967"
import script from "./ListChapter.vue?vue&type=script&lang=js"
export * from "./ListChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports